<script lang="ts">
  import { type FacetValue, Chip } from "@otto-ec/heureka-components/facet-value";
  import { type FacetValueLabelOptions, Text } from "@otto-ec/heureka-components/facet-value-label";
  import DeselectAll from "../facetvaluetags/DeselectAll.svelte";
  import type { DeselectAllConfiguration } from "./type";
  import { OverflowBox } from "@otto-ec/heureka-components/facet-value-group";

  const defaultFacetValueLabelOptions: Partial<FacetValueLabelOptions> = {
    size: "75",
    showCount: false,
  };

  interface Props {
    deselectAll: DeselectAllConfiguration;
    values?: FacetValue[];
  }

  const { deselectAll, values }: Props = $props();
  const hasValues = values?.length > 0;
</script>

{#snippet closeIcon()}
  <svg class="hc_facetValue__icon" role="img">
    <use href="/assets-static/icons/pl_icon_close50.svg#pl_icon_close50"></use>
  </svg>
{/snippet}

{#snippet chip(facetValue: FacetValue)}
  <Chip {...facetValue}>
    <Text {...facetValue} {...defaultFacetValueLabelOptions} />
    {#if facetValue.checked}
      {@render closeIcon()}
    {/if}
  </Chip>
{/snippet}

<div class="hc_facetValueTags">
  {#if hasValues}
    <div class="hc_facetValueTags__content">
      <div class="hc_facetValueTags__values">
        <OverflowBox {values} item={chip}></OverflowBox>
      </div>
      <div class="hc_facetValueTags__deselectAll">
        <DeselectAll {...deselectAll} />
      </div>
    </div>
  {/if}
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  .hc_facetValueTags {
    margin-bottom: tokens.$oc-semantic-spacing-50;

    &__content {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 14px 0;
    }

    &__values {
      overflow-x: auto;
      overflow-y: hidden;
      scrollbar-width: none;

      .hc_facetValue__icon {
        width: tokens.$oc-semantic-spacing-75;
        height: tokens.$oc-semantic-spacing-75;
        margin-left: tokens.$oc-semantic-spacing-25;
      }
    }

    &__deselectAll {
      flex: 1;
      white-space: nowrap;
      text-align: right;
      padding-left: tokens.$oc-semantic-spacing-75;
      padding-right: tokens.$oc-semantic-spacing-25;
    }
  }
</style>
